import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom"

import TableBrakes from './components/TableBrakes';
import GetDataDetail from '../../services/loaderService';
import TitleComponent from '../../components/titleComponent/TitleComponent';
import config from '../../config';

const domain = config.api_domain.domain

const Brakes = () => {
    const params = useParams()
    const url = `${domain}/brakes`
    const id = params.id
    const [cleanDataDetail, setcleanDataDetail] = useState([])
      
    useEffect(() => {
        GetDataDetail(setcleanDataDetail, url, id)
    }, [id, url, setcleanDataDetail])
    
    return (
        <div className='content'>
            <div className=''>
                <TitleComponent text={'Frenos'} />
                <TableBrakes data={cleanDataDetail} />
            </div>
        </div>
    )
}

export default Brakes;